/**
 * PiedDePage — PEFEP Site
 * ---------------------------------------------------------------
 * Pied de page partage par toutes les pages publiques.
 *
 * Logo : nouveau logo PEFEP Site (public/logo-pefep-site.png,
 * version fond blanc) remplacant l'ancien assets/logo-complet.png.
 *
 * Les classes .contact-footer, .contact-container et .footer-link
 * viennent de PageContact.css.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

const LOGO_PEFEP_SITE = process.env.PUBLIC_URL + '/logo-pefep-site.png';

function PiedDePage() {
  const navigate = useNavigate();

  const liens = [
    { libelle: 'Accueil', chemin: '/' },
    { libelle: 'À propos', chemin: '/qui-sommes-nous' },
    { libelle: 'Tarifs', chemin: '/tarifs' },
    { libelle: 'Domaines', chemin: '/domaines' },
    { libelle: 'FAQ', chemin: '/faq' },
    { libelle: 'Contact', chemin: '/contact' },
    { libelle: 'Confidentialité', chemin: '/politique-de-confidentialite' },
    { libelle: "Conditions", chemin: '/conditions-d-utilisation' },
  ];

  return (
    <footer className="contact-footer">
      <div className="contact-container" style={{ textAlign: 'center' }}>
        <img
          src={LOGO_PEFEP_SITE}
          alt="PEFEP Site"
          style={{ height: 48, width: 'auto', background: '#fff', borderRadius: 10, padding: 6, marginBottom: 10 }}
        />
        <p
          style={{
            color: 'rgba(255,255,255,0.7)',
            fontSize: 13,
            fontStyle: 'italic',
          }}
        >
          Votre site web professionnel, créé en quelques minutes
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 20,
            marginTop: 16,
            flexWrap: 'wrap',
          }}
        >
          {liens.map(function (lien) {
            return (
              <button
                type="button"
                className="footer-link"
                key={lien.chemin}
                onClick={function () {
                  navigate(lien.chemin);
                }}
              >
                {lien.libelle}
              </button>
            );
          })}
        </div>

        <p
          style={{
            color: 'rgba(255,255,255,0.4)',
            fontSize: 12,
            marginTop: 20,
          }}
        >
          © 2026 PEFEP Site — Tous droits réservés | pefep.site
        </p>
      </div>
    </footer>
  );
}

export default PiedDePage;